import React from "react";
import l from "components/util/l";

const RevisionProposalActions = ({
  isCreatingDevRevision,
  onClickEditProposal,
}) => (
  <div className="d-flex w-100 justify-content-end mt-2">
    <button
      type="button"
      className="btn btn-sm btn-outline-primary-white mr-2 mb-2 mb-md-0"
      onClick={onClickEditProposal}
      disabled={isCreatingDevRevision}
    >
      {isCreatingDevRevision ? (
        <>
          <i className="fas fa-spinner fa-pulse mr-2"></i>
          {l("Creando...%PA342")}
        </>
      ) : (
        <>
          <i className="fas fa-pen mr-2"></i>
          {l("Editar%GA002")}
        </>
      )}
    </button>
  </div>
);

export default RevisionProposalActions;
